import { initWidget } from '../../utils/Shell';
import CartOverviewWidget from './CartOverviewWidget.vue';

initWidget('CartOverviewWidget', CartOverviewWidget);
